export default "__VITE_ASSET__Dxi$ae2r__"